import React, { Fragment } from "react";


const MenuPuff = ({
  megaMenuPuffHeader,
  megaMenuPuffDescription,
  megaMenuPuffImage,
  megaMenuPuffLink,
}) => (
  <div className="menu-puff">
    <a href={megaMenuPuffLink} className="menu-puff__wrapper-link">
      <div className="menu-puff__inner-wrapper">
        <picture className="menu-puff--image">
          <img src={megaMenuPuffImage} />
        </picture>
        <div className="menu-puff__text">
          <div className="menu-puff__text--header">{megaMenuPuffHeader}</div>
          <div className="menu-puff__text--description">{megaMenuPuffDescription}</div>
        </div>
      </div>
    </a>
  </div>
)



export default MenuPuff;
